import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

const indexSkus = gql`
    query indexSku {
        indexSku
    }
`;

export const useIndexSku = (productSku: string) => {
    const { data: skus } = useQuery(indexSkus);

    return Boolean(skus?.indexSku?.find((sku) => sku === productSku));
};
